import StringConstants from '../constants/StringConstants';
import brandUtils from './brandUtils';

export const ACTIVE_ZILLOW_THEME = 'zillow';
export const ACTIVE_HOTPADS_THEME = 'legacy-zillow';

export default function getPandaThemeAttributes(brand: Brand): Record<string, string | undefined> {
  const isHotpads = brandUtils.isHotpads(brand);

  return {
    'data-panda-theme': isHotpads ? ACTIVE_HOTPADS_THEME : ACTIVE_ZILLOW_THEME,
    'data-panda-theme-customized': isHotpads ? StringConstants.UNFORMATTED_BRAND_NAMES.hotpads : undefined,
  };
}
